import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
  Button,
  ClickAwayListener,
  Grid,
  Grow,
  MenuList,
  Paper,
  Popper,
  PopperPlacementType,
  Typography,
} from '@mui/material';
import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { useMenu } from './range-time-slider-hooks';
import { MenuHandle } from './types';

interface MenuPopupProps {
  children: React.ReactElement;
  menuHandle: MenuHandle;
  placement: PopperPlacementType;
}

const MenuPopup = (props: MenuPopupProps) => {
  const { placement, children, menuHandle } = props;
  return (
    <Popper
      open={menuHandle.opened}
      anchorEl={menuHandle.anchorEl as HTMLElement}
      transition={true}
      placement={placement}
      style={{
        zIndex: 1500,
      }}
    >
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: 'center top',
          }}
        >
          <Paper style={{ backgroundColor: '#29a599', color: '#FFF' }}>
            <ClickAwayListener onClickAway={menuHandle.close}>
              {children}
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

interface MenuButtonProps {
  label: string;
  menuHandle: MenuHandle;
}

const MenuButton = (props: MenuButtonProps) => {
  const { label, menuHandle } = props;
  return (
    <Button
      aria-haspopup="true"
      onClick={(e: MouseEvent) => {
        menuHandle.open();
        menuHandle.setAnchorEl(e.currentTarget.parentNode);
      }}
    >
      <div>
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          <ArrowDropDownIcon fontSize="small" />
        </Typography>
      </div>
    </Button>
  );
};

const ColoredPaper = styled(Paper)`
  background-color: ${(props) => props.theme.color.clientPrimary};
`;

const StyledMenuList = styled(MenuList)`
  padding: 0;
`;

interface MenuProps {
  label: string;
  children: React.ReactNode;
}

export const Menu = (props: MenuProps) => {
  const { label, children } = props;
  const menuHandle = useMenu();
  return (
    <Grid
      item
      style={{ height: '8vh', minWidth: '113px', textAlign: 'center' }}
    >
      <ColoredPaper style={{ minHeight: '100%', height: '100%' }}>
        <MenuButton label={label} menuHandle={menuHandle} />
        <MenuPopup menuHandle={menuHandle} placement="bottom-start">
          <StyledMenuList>{children}</StyledMenuList>
        </MenuPopup>
      </ColoredPaper>
    </Grid>
  );
};
